import "./chunk-2HYBKCYP.js";

// src/types.ts
var dataTagSymbol = Symbol("dataTagSymbol");
var dataTagErrorSymbol = Symbol("dataTagErrorSymbol");
var unsetMarker = Symbol("unsetMarker");
export {
  dataTagErrorSymbol,
  dataTagSymbol,
  unsetMarker
};
//# sourceMappingURL=types.js.map